import React from 'react'
import UserProfileContainer from '../../../../Components/Apps/Users/UserProfile'

export default function UserProfile() {
  return (
    <div className='page-body'>
        <UserProfileContainer/>
    </div>
  )
}
